// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--2ckXP","top":"Layout-module--top--1Yv8H","bottom":"Layout-module--bottom--2DG9A"};